import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import type { authState } from "modules/auth";
import { APPLE_PROVIDER_ID } from "constants/firebase";

export type SNSLinkageStatus = {
  google: boolean;
  twitter: boolean;
  apple: boolean;
};
export const getSNSLinkageStatus = (
  user: authState["user"]
): SNSLinkageStatus => {
  return {
    google:
      user.providerData.findIndex(
        // @ts-expect-error TS18047
        (el) => el.providerId === firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ) >= 0,
    twitter:
      user.providerData.findIndex(
        // @ts-expect-error TS18047
        (el) => el.providerId === firebase.auth.TwitterAuthProvider.PROVIDER_ID
      ) >= 0,
    apple:
      user.providerData.findIndex(
        // @ts-expect-error TS18047
        (el) => el.providerId === APPLE_PROVIDER_ID
      ) >= 0,
  };
};
